import { isNumber, isString, isUndefined } from 'lodash-es'
import { DataHelper } from './DataHelperTypes'

export function parseEnum(enumKey: string | undefined, Enum: any, helper?: DataHelper<any>): any | null {
  if (enumKey) {
    const enumValues = getEnumValues(Enum)

    const enumValue = enumValues.find((value: any) => {
      if (helper) {
        return helper.getName(value).toUpperCase() === enumKey.toUpperCase()
      } else if (isNumber(value)) {
        return Enum[value].toString().toUpperCase() === enumKey.toUpperCase()
      } else {
        return value.toUpperCase() === enumKey.toUpperCase()
      }
    })

    return isUndefined(enumValue) ? null : enumValue
  } else {
    return null
  }
}

export function getEnumValues(Enum: {}): any[] {
  const isNumericEnum = Object.values(Enum).some(isNumber)
  return Object.values(Enum).filter(key => (isNumericEnum ? isNumber(key) : isString(key)))
}
